import format from 'date-fns/format';

const arrayToObject = (arr, keyField) =>
    Object.assign({}, ...arr.map((item) => ({ [item[keyField]]: item })));

  export const getCurrentYear = () => {
    return format(new Date().setFullYear(new Date().getFullYear()), 'yyyy');
  }

  export const createYearRange = (startOffset = -1, endOffset = +1) => {
    var yearsArr = [];
    var currentYear = new Date().getFullYear();

    for (var i = startOffset; i <= endOffset; i++) {
      yearsArr.push({ id: currentYear + i, label: currentYear + i });
    }
    return arrayToObject(yearsArr, 'id');
  };
